<template>
  <div>
    <PageSpinner :onloader="onloader" />
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <router-link to="/dashboard" class="text-white pl-3">
        Dashboard</router-link>    
      <span class="text-white"><i class="fa fa-ellipsis-v px-2"></i> School Details</span>
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--7">
      <card header-classes="bg-transparent">
        <div class="card bg-secondary border-0 mb-0">
          <div class="card-body">
            <div class="form-horizontal">
              <form role="form" @submit.prevent="submitdata">
                <div class="row">
                  <div class="col-md-12 pb-2">
                    <div class="row">
                      <div class="col">
                        <img v-if="ImgPathval" :src="ImgPathval" class="img-fluid" />
                        <img v-else src="/img/brand/empty.png" class="img-fluid" />
                      </div>
                      <div class="col">
                        <ImageUploader @emitOutImgPathval="updatePassportVal" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>School Name</label>
                      <input v-model="schoolname" class="form-control" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Short Name</label>
                      <input v-model="shortname" class="form-control" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>SMS Header</label>
                      <input v-model="smsheader" class="form-control" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Phone No.</label>
                      <input type="tel" v-model="phoneno" class="form-control" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Email Address</label>
                      <input type="email" v-model="emailladd" class="form-control" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Web Address</label>
                      <input v-model="webadd" class="form-control" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>State</label>
                      <select v-model="state" class="form-control" @change="getlga()">
                        <option v-for="item in stateitems" :key="item.Id" v-bind:value="item.Id">
                          {{ item.StateName }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Local Government</label>
                      <select v-model="lga" class="form-control">
                        <option v-for="item in lgaitems" :key="item.Id" v-bind:value="item.Id">
                          {{ item.Local_Govt_Name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>City</label>
                      <base-input v-model="city"></base-input>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Address</label>
                      <textarea v-model="address" class="form-control"></textarea>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Bank</label>
                      <select v-model="bankid" class="form-control">
                        <option v-for="item in bankitems" :key="item.Id" v-bind:value="item.Id">
                          {{ item.BankName }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Account Name</label>
                      <input v-model="accountname" class="form-control" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Account Number</label>
                      <input v-model="accountno" class="form-control" />
                    </div>
                  </div>
                </div>
                <div class="text-center mb-3">
                  <input type="hidden" v-model="addressid" />
                  <button type="submit" class="btn btn-primary my-4">
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Alert from "@/mixins/Alert.mixins"
import PageSpinner from "@/components/PageSpinner";
import ImageUploader from "@/components/ImageUploader"
export default {
  name: "schoolDetails",
    mixins: [Alert],
  components: {
    PageSpinner, ImageUploader
  },
  data() {
    return {
      accessDetails: null,
      schoolname: "",
      shortname: "",
      smsheader: "",
      phoneno: "",
      emailladd: "",
      webadd: "",
      state: "",
      lga: "",
      lgaitems: [],
      city: "",
      address: "",
      bankid: "",
      accountname: "",
      accountno: "",
      ImgPathval: "",
      addressid: "",
      file: "",
      uploadedimage: "",
      process: "N",
      onloader: "none",
    };
  },
  computed: {
    ...mapState({
      stateitems: (state) => state.addressinfo.stateitems,
      bankitems: (state) => state.appdatas.bankitems,
      schoolitems: (state) => state.schooldata.schoolinfo,
    }),
  },
  methods: {
    getschoolinfo: function () {
      this.onloader = "flex";
      this.$store
        .dispatch("getschooldetails")
        .then((resp) => {
          this.schoolname = resp.Org_Name;
          this.shortname = resp.ShortName;
          this.smsheader = resp.MessageHeader;
          this.address = resp.AddressOne;
          this.bankid = resp.BankId;
          this.accountname = resp.AccountName;
          this.accountno = resp.AccountNumber;
          if (resp.Logo != null) {
            this.uploadedimage = resp.Logo;
          }         
          this.ImgPathval = resp.Logo;
          this.addressid = resp.AddId;
          this.phoneno = resp.Phone_No;
          this.webadd = resp.Web_Add;
          this.state = resp.StateId;
          this.getlga();
          this.lga = resp.LGId;
          this.city = resp.City;
          this.emailladd = resp.Email_Add;
          this.onloader = "none";
        })
        .catch((err) => {
          this.onloader = "none";
          console.log(err);
          this.ShowAlertError(err.response.data, '');
        });
    },
    getlga: function () {
      this.onloader = "flex";
      this.lgaitems = [];
      let StateId = this.state;
      this.$store
        .dispatch("getlgas", StateId)
        .then((resp) => {
          this.lgaitems = resp;
          this.onloader = "none";
        })
        .catch((err) => {
          this.onloader = "none";
          this.ShowAlertError(err.response.data, '');
        });
    },

    submitdata: function () {
      let Id = 1;
      let SchoolName = this.schoolname;
      let ShortName = this.shortname;
      let SMSHeader = this.smsheader;
      let PhoneNo = this.phoneno;
      let EmailAdd = this.emailladd;
      let Logo = this.logo;
      let WebAddress = this.webadd;
      let AddressId = this.addressid;
      let StateId = this.state;
      let LgaId = this.lga;
      let City = this.city;
      let Address = this.address;
      let BankId = null;
      if (this.bankid != "") {
        BankId = this.bankid;
      }
      let AccountName = this.accountname;
      let AccountNo = this.accountno;
      let processop = this.process;
      let username = this.$store.state.auth.username;
      let accesskey = this.$store.state.auth.accesskey;
      let payload = {
        Id,
        SchoolName,
        ShortName,
        SMSHeader,
        PhoneNo,
        EmailAdd,
        Logo,
        WebAddress,
        AddressId,
        StateId,
        LgaId,
        City,
        Address,
        BankId,
        AccountName,
        AccountNo,
        processop,
        username,
        accesskey,
      };

      this.onloader = "flex";
      this.$store
        .dispatch("schoolupdate", payload)
        .then(() => {
          this.getschoolinfo();
          this.onloader = "none";
         this.ShowAlertSuccess('Submitted Successfully', '');
        })
        .catch((err) => {
          this.onloader = "none";
          this.ShowAlertError(err.response.data, '');
        });
    },
    updatePassportVal(data) {
      this.ImgPathval = data;
    },
   
   
  },
  mounted() {
    const userDetails = this.accessDetails = this.$store.getters['auth/_user'];
    if (
      userDetails.isSchoolStaff == false
    ) {
      this.$store.dispatch("auth/Logout");
      this.$router.push("/login");
    } else {
      this.getschoolinfo();
    }
  },
};
</script>

<style></style>
